import { FC } from 'react'
import { IArticleBase } from '@/types'
import { getArticleThumbnail } from '@/utils'
import { ListingSearchResult } from '@components-v2/molecules/ListingSearchResult'
import { ArticleCardContent } from '@components-v2/molecules/ArticleCardContent'
import { observer } from 'mobx-react'

type Props = {
  article: IArticleBase
}

export const ArticleCard: FC<Props> = observer(({ article }) => {
  return (
    <ListingSearchResult href={`/articles/${article?.slug}`} src={getArticleThumbnail(article)} alt={article?.title}>
      <ArticleCardContent article={article} />
    </ListingSearchResult>
  )
})
